export const X_URL = "https://x.com/ARCMECH";
export const BUY_URL = "https://argus.world/token/0x5e01e5A64afC4F65C4007c9049B4845C319af5aD";
export const DEXSCREENER_URL = "https://dexscreener.com/arc/0xd89529e01814f47697c161fe80b9853e05fa55875cf7c6c629a3c1e4a75ecfbd";
export const SITE_URL = "https://archmech.tech";
export const CONTRACT_ADDRESS = "0x5e01e5A64afC4F65C4007c9049B4845C319af5aD";
export const NETWORK_NAME = "ARC";
export const TOKEN_SYMBOL = "$ARCMECH";

export const ASSETS = {
  logo: "/assets/arcmech-logo.png",
  banner: "/assets/arcmech-ban.webp",
  commandBg: "/assets/arcmech-bg.png",
};
